import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'finArrayIndex',
  standalone: false,
})
export class ArrayIndexPipe implements PipeTransform {
  transform<T>(array: T, index: number): T | undefined {
    return array?.[index];
  }
}
